module.exports = __webpack_public_path__ + "static/l1-dc85bfd64b42f49111576048a2298de9.jpg";